/* @description Returns '&' concanated String having utm params values.
The order of the params in the returned string would be same
as the order of items in @param{String} utmArrayData
@return {String} or NULL if all parameters are null or undefined
*/
import { createUrl, getQueryParams } from './index';
import { extractUtmData } from './functionUtils';
import { getValueDirectlyFromTranslationsReducer } from '../services/Localisation';

export function getConcatanatedUTMData(utmItemsArray) {
  let concatanatedUTMData = '';
  const emptyParamValueToInsert = 'NA';
  let paramNullSumTracker = 0;

  utmItemsArray.map((utmItem, index) => {
    if (utmItem) {
      concatanatedUTMData += index > 0 ? '&' + utmItem : utmItem;
    } else {
      paramNullSumTracker++;
      concatanatedUTMData +=
        index > 0 ? '&' + emptyParamValueToInsert : emptyParamValueToInsert;
    }
  });

  if (paramNullSumTracker === utmItemsArray.length) {
    return null;
  }

  return concatanatedUTMData;
}

export function getCtaLinkWithUtmParams(ctaLink){
  let first_utm_source = getValueDirectlyFromTranslationsReducer('utm_source');
  let first_utm_medium = getValueDirectlyFromTranslationsReducer('utm_medium');
  let first_utm_campaign = getValueDirectlyFromTranslationsReducer('utm_campaign');
  if(!first_utm_source && !first_utm_medium && !first_utm_campaign) return ctaLink;
  const positionOfQuestionMark = ctaLink.indexOf('?');
  if(positionOfQuestionMark > 0 ) {
    const queryParams = getQueryParams(ctaLink);
    const { utm_source, utm_medium, utm_campaign } = extractUtmData(queryParams);
    first_utm_source += utm_source ? '_' + utm_source : '';
    first_utm_medium += utm_medium ? '_' + utm_medium : '';
    first_utm_campaign += utm_campaign ? '_' + utm_campaign : '';
    return ctaLink.substr(0,positionOfQuestionMark) + createUrl(null,false,{ ...queryParams, utm_source : first_utm_source, utm_medium: first_utm_medium, utm_campaign: first_utm_campaign }) ;
  }
  else return ctaLink + createUrl(null,false,{ utm_source : first_utm_source, utm_medium: first_utm_medium, utm_campaign: first_utm_campaign });
}
